import cls from 'classnames';
import * as React from 'react';

import { FieldProps, getIn } from 'formik';

const styles = require('./InputFile.scss');

interface Props extends FieldProps {
    // Text to show in the button
    label: string;

    // Whether or not to use primary style
    primary?: boolean;

    // Which size to render
    size?: 'small' | 'large';

    // Whether or not we want to allow multiple file upload
    multi?: boolean;
}

export class ButtonFileInput extends React.Component<Props> {
    inputRef: HTMLInputElement | null;

    static defaultProps: Partial<Props> = {
        size: 'small',
    };

    constructor(props: Props) {
        super(props);

        this.resetInput = this.resetInput.bind(this);
    }

    render() {
        const { form, field, size, primary, label, multi } = this.props;

        // Before we rerender we need to handle the case where the input
        // was reset via formik.setFieldValue.
        if (!field.value || field.value.length === 0) {
            this.resetInput();
        }

        return (
            <div>
                <input
                    ref={(e) => {
                        this.inputRef = e;
                    }}
                    type='file'
                    name={field.name}
                    multiple={!!multi}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (!!e.currentTarget.files) {
                            form.setFieldValue(field.name, Array.from(e.currentTarget.files));
                        }
                        form.setFieldTouched(field.name, true);
                    }}
                    onClick={() => {
                        if (!!this.inputRef) {
                            // Clear this input on click to force re-set the input
                            // every time user clicks the upload button
                            form.setFieldValue(field.name, []);
                        }
                    }}
                />
                <button
                    className={cls('nx-button', {
                        'nx-button--small': size === 'small',
                        'nx-button--large': size === 'large',
                        'nx-button--primary': primary,
                    })}
                    type='button'
                    onClick={() => {
                        !!this.inputRef && this.inputRef.click();
                    }}
                >
                    {label}
                </button>
                <div className={styles.filename}>
                    {field.value.length > 0 &&
                        field.value.map((item: File, idx: number) => {
                            return (
                                <div className='' key={idx}>
                                    {item.name}
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    }

    private resetInput() {
        if (!!this.inputRef) {
            this.inputRef.value = '';
        }
    }
}

export default ButtonFileInput;
